import React from 'react';
import { connect } from 'react-redux';
import { CMSContent, getCMSObject } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';
import scbzLogo from '../images/logos/scbz.png';

const LegalPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.legalNotices.pageInfo.pageTitle'),
        className: 'legal',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='static-content'>
                <div className='block'>
                    <img alt='Second Chance Bonus Zone' src={scbzLogo} />
                    <CMSContent
                        localStorageObject='webContent'
                        contentPath='data.microsite.general.legalNotices.contentHTML'
                        cmsSourceFirebase={cmsSourceFirebase}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalPage);
